import InputMask from "@amzn/meridian/input/mask";
import {
    ADTA_ASSET_TYPE,
    ADTF_ASSET_TYPE,
    ASL_ASSET_TYPE,
    AUTO_RETRIEVER_ASSET_TYPE,
    BLUE_COLOR,
    CATCH_ALL_INSTALLATION_TYPES, NO_PRINTER_ASSIGNED,
    ORANGE_COLOR,
    TESSERACT_ASSET_TYPE, UNASSIGN_PRINTER
} from "./Constants";
import {getCurrentDate} from "./Util";

export const MAC_MASK = new InputMask(
    '^^:^^:^^:^^:^^:^^',
    {
        formatChars: {
            '^': '[0-9a-fA-F]'
        }
    }
);
export const DIVERT_CODE_MASK = new InputMask(
    '^^',
    {
        formatChars: {
            '^': '[0-9]'
        }
    }
);

export const SCANLESS_SUPPORTED_CART_RECIPES_NA = {
    NON_OV: ["AMZL_NON_OV_COLUMN_TYPE2"],
    TWO_TIER_OV: ["AMZL_OV_COLUMN_TYPE3", "AMZL_OV_COLUMN_TYPE2"],
}

export const SCANLESS_SUPPORTED_CART_RECIPES_JP = {
    NON_OV: ["AMZL_NON_OV_COLUMN_TYPE2"],
    TWO_TIER_OV: ["AMZL_OV_COLUMN_TYPE3"],
    ONE_TIER_OV: ["AMZL_OV_COLUMN_TYPE2"],
}

export const SCANLESS_SUPPORTED_CART_RECIPES_EU = {
    NON_OV: ["AMZL_NON_OV_COLUMN_TYPE2"],
    TWO_TIER_OV: ["AMZL_OV_COLUMN_TYPE3"],
}

export const PROTOCOLS = {
    ADTA: ['sort', 'sort-2021-v1', 'sort-mercury-2.04'],
    ADTF: ['matrix-v1'],
    ASL: ['slam', 'slam-2021-v1', 'slam-2021-v1.3', 'asl-a2c-v1'],
    ZANCASORT: ['asrs-a2c-v1'],
    TESSERACT: ['asrs-a2c-v1'],
    AUTO_RETRIEVER: ['asrs-a2c-v1'],
    ASML: ['asml-tcp-ip-v1']
}

export const VENDOR_INFO_KEYS = {
    VENDOR: ["actemium", "ami", "bastian", "caljan", "comind", "fives", "hokusho", "igem", "impact_automation", "intralox", "keikikou", "lac", "manergo", "meikikou", "mhs", "okura", "raymond", "ssi", "tgw", "lewco", "bluecrest", "ulma", "vanderlande", "zancaner", "galam", "other"],
    SPEC_VERSION: ["EU_deployment_v1.0", "EU_pilot_v1", "EU_pilot_v2", "EU_prod_v1", "EU_prod_v2", "EU_prod_v2_EU_deployment_v1.0", "EU_v0", "EU_v0.5", "EU_v1.0", "EU_v1.1", "EU_v1.5", "EU_v2", "EU_v3", "EU_v3.1", "FE_v0", "FE_v1", "FE_v3", "FE_v4", "NA_2021", "NA_2022", "NA 2023", "NA_v1.5", "pilot", "other"],
    SORTER_TYPE: ["intralox", "modsort", "other"],
    HAMPER_VENDOR: ["agito", "ami", "caljan", "cannon", "cmc", "fives", "ia", "iec", "interoll", "lewco", "meikikou", "muvro", "preceed", "tiffin", "other"],
    HAMPER_VERSION: ["EU_v0", "EU_v0.5", "EU_v1.0", "EU_v2.0", "EU_v2.1", "EU_pilot_v1", "NA_v1.0", "NA_v1.5", "NA_v2.3", "NA_2022", "FE_v0", "FE_v0.1", "FE_v0.2", "FE_v1", "FE_v2", "FE_v3", "other"]
};

export const VENDOR_DISPLAY_VALUES = {
    "actemium": "Actemium",
    "ami": "AMI",
    "bastian": "Bastian",
    "caljan": "Caljan",
    "comind": "Co.m.ind",
    "fives": "Fives",
    "hokusho": "Hokusho",
    "igem": "iGEM",
    "impact_automation": "Impact Automation",
    "intralox": "Intralox",
    "keikikou": "Keikikou",
    "lac": "LAC",
    "manergo": "Manergo",
    "meikikou": "Meikikou",
    "mhs": "MHS",
    "okura": "Okura",
    "raymond": "Raymond",
    "ssi": "SSI",
    "tgw": "TGW",
    "lewco": "Lewco",
    "ulma": "ULMA",
    "vanderlande": "Vanderlande",
    "bluecrest": "Bluecrest",
    "zancaner": "Zancaner",
    "galam": "Galam",
    "other": "Other"
}

export const SPEC_VERSION_DISPLAY_VALUES = {
    "EU_deployment_v1.0": "EU Deployment v1.0",
    "EU_pilot_v1": "EU Pilot v1",
    "EU_pilot_v2": "EU Pilot v2",
    "EU_prod_v1": "EU Prod v1",
    "EU_prod_v2": "EU Prod v2",
    "EU_prod_v2_EU_deployment_v1.0": "EU Prod v2 + EU Dep v1.0",
    "EU_v0": "EU v0",
    "EU_v0.5": "EU v0.5",
    "EU_v1.0": "EU v1.0",
    "EU_v1.1": "EU v1.1",
    "EU_v1.5": "EU v1.5",
    "EU_v2": "EU v2",
    "EU_v3": "EU v3",
    "EU_v3.1": "EU v3.1",
    "FE_v0": "FE v0",
    "FE_v1": "FE v1",
    "FE_v3": "FE v3",
    "FE_v4": "FE v4",
    "NA_2021": "NA 2021",
    "NA_2022": "NA 2022",
    "NA 2023": "NA 2023",
    "NA_v1.5": "NA v1.5",
    "pilot": "Pilot",
    "other": "Other"
};

export const SORTER_TYPE_DISPLAY_VALUES = {
    "intralox": "Intralox",
    "modsort": "Modsort",
    "other": "Other"
};

export const HAMPER_VENDOR_DISPLAY_VALUES = {
    "agito": "AGITO",
    "ami": "AMI",
    "caljan": "Caljan",
    "cannon": "Cannon",
    "cmc": "CMC",
    "fives": "Fives",
    "ia": "IA",
    "iec": "IEC",
    "interoll": "Interoll",
    "lewco": "Lewco",
    "meikikou": "Meikikou",
    "muvro": "Muvro",
    "preceed": "Preceed",
    "tiffin": "Tiffin",
    "other": "Other"
};

export const HAMPER_VERSION_DISPLAY_VALUES = {
    "EU_v0": "EU v0",
    "EU_v0.5": "EU v0.5",
    "EU_v1.0": "EU v1.0",
    "EU_v2.0": "EU v2.0",
    "EU_v2.1": "EU v2.1",
    "EU_pilot_v1": "EU Pilot v1",
    "NA_v1.0": "NA v1.0",
    "NA_v1.5": "NA v1.5",
    "NA_v2.3": "NA v2.3",
    "NA_2022": "NA 2022",
    "FE_v0": "FE v0",
    "FE_v0.1": "FE v0.1",
    "FE_v0.2": "FE v0.2",
    "FE_v1": "FE v1",
    "FE_v2": "FE v2",
    "FE_v3": "FE v3",
    "other": "Other"
}

export const PATTERNS = {
    NAME: /^[A-Za-z0-9 -;]{1,50}$/,
    SLAM: /^slam-2021-v1\.[0-9]$/,
    MAC: /^([0-9a-fA-F]{2}[:]){5}([0-9a-fA-F]{2})$/,
    MAC_MASK: /([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})/,
    BAY_ID: /^[A-Za-z0-9 _@.#&+-|]{1,50}$/,
    CONTAINER_TYPE: /^[A-Za-z0-9_-]{1,20}$/,
    CONTAINER_LABEL: /^([A-Z])(-)?([1-9])$/,
    BAG_LABEL: /^[A-Z][-A-Z0-9_]{0,19}$/,
    DEVICE_ID: /^[A-Z0-9]{1,4}$/,
    PORT: /^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/,
    CLUSTERS: /^([A-Z]|(([A-Z];)*[A-Z]))$/,
    PICK_STATIONS: /^([A-Z0-9_]{2,10})(;[A-Z0-9_]{2,10})*$/,
    LOCATION: /^([A-Z]|(([A-Z];)*[A-Z]))$|^([A-Z],[0-9]{1,3})(;[A-Z],[0-9]{1,3}){0,2}$|^[A-Za-z0-9]$|^[A-B].L[0-9]{0,3}$|^[A-Z].L[0-9]{0,3}.[A-Z]{2}$/,
    CATCH_ALL_LOCATION: /^$|^([A-Z]|(([A-Z];)*[A-Z]))$|^([A-Z],[0-9]{1,3})(;[A-Z],[0-9]{1,3}){0,2}$|^[A-Za-z0-9]$|^[A-B].L[0-9]{0,3}$|^[A-Z].L[0-9]{0,3}.[A-Z]{2}$/,
    TEST_SCANNABLE: /^([A-Za-z_\-0-9]{11,})(;[A-Za-z_\-0-9]{11,})*$/,
    TEST_PACKAGE_ID: /^([A-Za-z_\-0-9]{11,})$/,
    SORT_ZONE: /(([A-Z])(\d*)-(\d)([A-Z]))|(([A-Z])-(\d*).(\d)([A-Z]))|^[A-B].L[0-9]{0,3}$|^[A-Z].L[0-9]{0,3}.[A-Z]{2}$/,
    DIVERT_CODE: /^[1-9][0-9]$/,
    SHORT_STRING: /^[A-Za-z0-9 '_]{1,20}/,
    LONG_STRING: /^[A-Za-z0-9 '_]{1,200}/,
    DATE: /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/,
    AISLE: /^([A-Z]-(\d*))$|^([A-Z](\d*))$/,
}

export const ZERO_TO_255
    = "(\\d{1,2}|(0|1)\\"
    + "d{2}|2[0-4]\\d|25[0-5])";

// Regex for a digit from 0 to 255 and
// followed by a dot, repeat 4 times.
// this is the regex to validate an IP address.
export const IP_ADDRESS_PATTERN
    = new RegExp("^" + ZERO_TO_255 + "\\."
    + ZERO_TO_255 + "\\."
    + ZERO_TO_255 + "\\."
    + ZERO_TO_255 + "$");

export function isValidEntry(entry, regex) {
    const value = regex.test(entry);
    return value;
}

export function areAllInputsFulfilled(stateValues) {

    if(!stateValues.deviceType) return false;
    let areInputsFilled = stateValues.name
        && stateValues.mac
        && stateValues.ip
        && stateValues.port
        && stateValues.vendorAttributes
        && stateValues.vendorAttributes.vendor
        && stateValues.vendorAttributes.spec_version;

    if (stateValues.deviceType === 'slam') {
        return areInputsFilled
            && stateValues.deviceConfig.responsePort
            && stateValues.deviceConfig.inductLocation
            && stateValues.deviceConfig.userId;
    }

    areInputsFilled = areInputsFilled && stateValues.deviceConfig.id;

    if(stateValues.deviceType.includes("sort")) {
        return areInputsFilled
            && stateValues.vendorAttributes.sorter_type
            && stateValues.vendorAttributes.hamper_vendor
            && stateValues.vendorAttributes.hamper_version;
    }

    if(stateValues.deviceType.includes("matrix")) {
        return areInputsFilled && stateValues.vendorAttributes.sorter_type;
    }

    if(stateValues.deviceConfig.type === AUTO_RETRIEVER_ASSET_TYPE) {
        return areInputsFilled && stateValues.pickStations;
    }

    return areInputsFilled;
}

export function areAllInputsFulfilledForLidarController(stateValues) {
    let lidarControllerConfig = stateValues.lidarControllerConfig;
    return lidarControllerConfig
        && lidarControllerConfig.macAddress
        && lidarControllerConfig.ipAddress
        && lidarControllerConfig.startAisleLabel
        && lidarControllerConfig.endAisleLabel
        && lidarControllerConfig.nonOVCartRecipe
        && lidarControllerConfig.twoTierOVCartRecipe;
}

export function areAllInputsFulfilledForMonitoring(stateValues) {
    return stateValues.startTime && stateValues.endTime && stateValues.reason && stateValues.startTime <= stateValues.endTime;
}

export function areAllInputsFulfilledForConfig(config, assetType) {
    if (assetType === ADTA_ASSET_TYPE) {
        if (CATCH_ALL_INSTALLATION_TYPES.includes(config.installation.type)) {
            return config.bayId && config.installation.type;
        } else {
            return config.bayId && config.installation.type && (config.installation.locations);
        }
    } else if (assetType === ADTF_ASSET_TYPE) {
        if (['miss', 'jackpot', 'ov'].includes(config.installation.type)) {
            return config.destinationId && config.sorterId && config.installation.type;
        } else {
            return config.destinationId && config.sorterId &&
                config.installation.type && config.installation.locations;
        }
    } else if (assetType === TESSERACT_ASSET_TYPE) {
        return config.containerType && config.containerLabel;
    } else if (assetType === ASL_ASSET_TYPE)
        return config.divertCode && config.clusters;
}

export function areAllInputsFulfilledForZancaSortTestPackage(stowTestPackage) {
    return stowTestPackage.scannables && stowTestPackage.destination;
}

export function areAllInputsFulfilledForTesseractTestPackage(stowTestPackage) {
    return stowTestPackage.trackingId && stowTestPackage.scannables && stowTestPackage.destination;
}

export function areAllInputsFulfilledForTestPackage(sorterTestPackage) {
        return sorterTestPackage.scannables && sorterTestPackage.sortZone;
}

export function validateNewAslDevice(stateValues) {
    if(PROTOCOLS.ASL.includes(stateValues.deviceType)) {
        if(stateValues.deviceType === 'slam') {
            return areAllInputsFulfilled(stateValues) &&
                isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
                isValidEntry(stateValues.mac, PATTERNS.MAC) &&
                isValidEntry(stateValues.port, PATTERNS.PORT) &&
                isValidEntry(stateValues.deviceConfig.responsePort, PATTERNS.PORT) &&
                isValidEntry(stateValues.deviceConfig.inductLocation, PATTERNS.SHORT_STRING) &&
                isValidEntry(stateValues.deviceConfig.userId, PATTERNS.SHORT_STRING) &&
                isValidEntry(stateValues.name, PATTERNS.NAME) &&
                VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
                VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version);
        } else {
            return areAllInputsFulfilled(stateValues) &&
                isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
                isValidEntry(stateValues.mac, PATTERNS.MAC) &&
                isValidEntry(stateValues.port, PATTERNS.PORT) &&
                isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
                isValidEntry(stateValues.name, PATTERNS.NAME) &&
                VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
                VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version);
        }
    } else {
        return false;
    }
}

export function validateNewAdtaDevice(stateValues) {
    return areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        PROTOCOLS.ADTA.includes(stateValues.deviceType) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        isValidEntry(stateValues.name, PATTERNS.NAME) &&
        VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
        VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version) &&
        VENDOR_INFO_KEYS.SORTER_TYPE.includes(stateValues.vendorAttributes.sorter_type) &&
        VENDOR_INFO_KEYS.HAMPER_VENDOR.includes(stateValues.vendorAttributes.hamper_vendor) &&
        VENDOR_INFO_KEYS.HAMPER_VERSION.includes(stateValues.vendorAttributes.hamper_version);
}

export function validateNewLidarController(stateValues) {
    return areAllInputsFulfilledForLidarController(stateValues) &&
        isValidEntry(stateValues.lidarControllerConfig.ipAddress, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.lidarControllerConfig.macAddress, PATTERNS.MAC) &&
        isValidEntry(stateValues.lidarControllerConfig.startAisleLabel, PATTERNS.AISLE) &&
        isValidEntry(stateValues.lidarControllerConfig.endAisleLabel, PATTERNS.AISLE);
}

export function validateNewAdtfDevice(stateValues) {
    return areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        PROTOCOLS.ADTF.includes(stateValues.deviceType) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        isValidEntry(stateValues.name, PATTERNS.NAME) &&
        VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
        VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version) &&
        VENDOR_INFO_KEYS.SORTER_TYPE.includes(stateValues.vendorAttributes.sorter_type);
}

export function validateNewZancaSortDevice(stateValues) {
    return areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.name, PATTERNS.NAME) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        PROTOCOLS.ZANCASORT.includes(stateValues.deviceType) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
        VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version)
}

export function validateNewTesseractDevice(stateValues) {
    return areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.name, PATTERNS.NAME) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        PROTOCOLS.TESSERACT.includes(stateValues.deviceType) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
        VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version)
}

export function validateNewAutoRetrieverDevice(stateValues) {
    return  areAllInputsFulfilled(stateValues) &&
        isValidEntry(stateValues.name, PATTERNS.NAME) &&
        isValidEntry(stateValues.mac, PATTERNS.MAC) &&
        isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
        isValidEntry(stateValues.port, PATTERNS.PORT) &&
        PROTOCOLS.AUTO_RETRIEVER.includes(stateValues.deviceType) &&
        isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
        VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
        VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version) &&
        isValidEntry(stateValues.pickStations, PATTERNS.PICK_STATIONS)
}

export function validateNewAsmlComponentDevice(stateValues) {
    if(PROTOCOLS.ASML.includes(stateValues.deviceType)) {
        return areAllInputsFulfilled(stateValues) &&
            isValidEntry(stateValues.ip, IP_ADDRESS_PATTERN) &&
            isValidEntry(stateValues.mac, PATTERNS.MAC) &&
            isValidEntry(stateValues.port, PATTERNS.PORT) &&
            isValidEntry(stateValues.deviceConfig.id, PATTERNS.DEVICE_ID) &&
            isValidEntry(stateValues.name, PATTERNS.NAME) &&
            VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor) &&
            VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version);
    } else {
        return false;
    }
}

export function validateNewAsmlDevice(stateValues) {
    return isValidEntry(stateValues.inductCameraMac, PATTERNS.MAC) &&
        (isValidEntry(stateValues.printerMac, PATTERNS.MAC) || stateValues.printerMac === UNASSIGN_PRINTER || stateValues.printerMac === NO_PRINTER_ASSIGNED)
}
export function validateNewControllerDevice(mac, ip, name) {
    return mac && ip && name && isValidEntry(ip, IP_ADDRESS_PATTERN) && isValidEntry(mac, PATTERNS.MAC) && isValidEntry(name, PATTERNS.NAME)
}

export function checkModalValidationsForMonitoring(stateValues) {
    return areAllInputsFulfilledForMonitoring(stateValues) &&
        isValidEntry(stateValues.reason, PATTERNS.LONG_STRING)
}

export function checkModalValidationsForConfig(stateValues, mac, assetType) {
    if (assetType === ADTA_ASSET_TYPE) {
        return areAllInputsFulfilledForConfig(stateValues, assetType) &&
            isValidEntry(stateValues.bayId, PATTERNS.BAY_ID) &&
            (['jackpot', 'recirculation','problem_solve'].includes(stateValues.installation.type)
                || (CATCH_ALL_INSTALLATION_TYPES.includes(stateValues.installation.type)
                    && isValidEntry(stateValues.installation.locations, PATTERNS.CATCH_ALL_LOCATION))
                || isValidEntry(stateValues.installation.locations, PATTERNS.LOCATION)) &&
            isValidEntry(mac, PATTERNS.MAC);
    } else if (assetType === ADTF_ASSET_TYPE) {
        // TODO: Add regex pattern for destinationId and sorterId
        return areAllInputsFulfilledForConfig(stateValues, assetType) &&
            (['miss', 'jackpot', 'ov'].includes(stateValues.installation.type)  ||
                isValidEntry(stateValues.installation.locations, PATTERNS.LOCATION)) &&
            isValidEntry(mac, PATTERNS.MAC);
    } else if (assetType === ASL_ASSET_TYPE) {
        return areAllInputsFulfilledForConfig(stateValues, assetType) &&
            isValidEntry(stateValues.divertCode, PATTERNS.DIVERT_CODE) &&
            isValidEntry(stateValues.clusters, PATTERNS.CLUSTERS) &&
            isValidEntry(mac, PATTERNS.MAC);
    } else if (TESSERACT_ASSET_TYPE === assetType) {
        return areAllInputsFulfilledForConfig(stateValues, assetType)
            && isValidEntry(stateValues.containerType, PATTERNS.CONTAINER_TYPE)
            && isValidEntry(stateValues.containerLabel, PATTERNS.CONTAINER_LABEL)
            && isValidEntry(mac, PATTERNS.MAC);
    }
}

export function validateAddDivertConfigModal(stateValues, mac, assetType) {
    return areAllInputsFulfilledForConfig(stateValues, assetType)
        && isValidEntry(stateValues.divertCode, PATTERNS.DIVERT_CODE)
        && stateValues.clusters.every((cluster) => isValidEntry(cluster, PATTERNS.CLUSTERS))
        && isValidEntry(mac, PATTERNS.MAC);
}

export function checkZancaSortAddTestPackageModalValidations(stateValues) {
    return areAllInputsFulfilledForZancaSortTestPackage(stateValues)
        && stateValues.scannables.every((entry) => isValidEntry(entry, PATTERNS.TEST_SCANNABLE))
        && isValidEntry(stateValues.destination, PATTERNS.BAG_LABEL)
}

export function checkTesseractAddTestPackageModalValidations(stateValues) {
    return areAllInputsFulfilledForTesseractTestPackage(stateValues)
        && isValidEntry(stateValues.trackingId, PATTERNS.TEST_PACKAGE_ID)
        && stateValues.scannables.every((entry) => isValidEntry(entry, PATTERNS.TEST_PACKAGE_ID))
        && stateValues.scannables.includes(stateValues.trackingId)
        && stateValues.scannables.length <= 2
        && isValidEntry(stateValues.destination, PATTERNS.CONTAINER_LABEL)
}

export function checkModalValidationsForTestPackage(stateValues) {
        return areAllInputsFulfilledForTestPackage(stateValues)
            && stateValues.scannables.every((entry) => isValidEntry(entry, PATTERNS.TEST_SCANNABLE))
            && isValidEntry(stateValues.sortZone, PATTERNS.SORT_ZONE)
}

function isValidTimestamp(timestamp) {
    const newTimestamp = new Date(Number(timestamp)).getTime();
    return isNumeric(newTimestamp);
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export function checkDeviceMonitoringEnabled(deviceMonitoringStartTime, deviceMonitoringEndTime) {
    if(!isValidTimestamp(deviceMonitoringStartTime) || !isValidTimestamp(deviceMonitoringEndTime)) {
        return {isMonitoringEnabled: true, isValidEntry: false};
    }
    if(getCurrentDate() < deviceMonitoringStartTime || getCurrentDate() > deviceMonitoringEndTime) {
        return {isMonitoringEnabled: true, isValidEntry: true};
    }
    return {isMonitoringEnabled: false, isValidEntry: true};
}

export function getMonitoringStatusDetails(deviceMonitoring) {
    return (deviceMonitoring.isValidEntry ?
        (deviceMonitoring.isMonitoringEnabled ?
            {monitoringStatusColor: BLUE_COLOR, monitoringStatusId: 'device.monitoringEnabled', monitoringStatusDefaultMessage: 'Enabled'}:
            {monitoringStatusColor: ORANGE_COLOR, monitoringStatusId: 'device.monitoringDisabled', monitoringStatusDefaultMessage: 'Disabled'})
        : {monitoringStatusColor: BLUE_COLOR, monitoringStatusId: 'device.invalidEntry', monitoringStatusDefaultMessage: 'Invalid Entry'})
}

export function checkModalValidationsForTriggeringMHEValidation(stateValues, dateTimeInput) {
    return !isStartTimeLaterThanEndTime(stateValues) && !isDurationMoreThanTwelveHours(stateValues)
        && isFromAndToDateTimeEntered(dateTimeInput);
}

export function isStartTimeLaterThanEndTime(stateValues) {
    return stateValues.startTime >= stateValues.endTime;
}

export function isDurationMoreThanTwelveHours(stateValues) {
    return Math.abs(stateValues.endTime - stateValues.startTime) > 12 * 60 * 60 * 1000;
}

export function isFromAndToDateTimeEntered(dateTimeInput) {
    return dateTimeInput.valueDateFrom.length > 0 && dateTimeInput.valueDateTo.length > 0 &&
        dateTimeInput.valueTimeFrom.length > 0 && dateTimeInput.valueTimeTo.length > 0;
}



// WEBPACK FOOTER //
// ./src/components/util/Validations.js